import { IPuzzleData, IPuzzle } from 'js/crossword/types';
import { getCustomisationOptions } from "./getCustomisationOptions";

export function convertPuzzleDataToPuzzleState(data: IPuzzleData): IPuzzle {
  data.clues.forEach((clue) => {
    clue.text = escapeHTMLCharacters(clue.text);
  });

  const customizationOptions = getCustomisationOptions();

  return {
    ...data,
    currentCellId: data.clues[0].cells[0],
    currentClueId: data.clues[0].id,
    autocheck: !customizationOptions.disableAutocheck,
    paused: false,
    time: 0,
    wrap: true,
    rebus: false,
    fillRate: 0,
    completed: false,
  };
}

const div = document.createElement('div');
function escapeHTMLCharacters(text: string): string {
  div.innerHTML = text;
  return div.innerText;
}
